import type { Maybe } from '@/frontend-types'

export type ContentLayout = 'wide' | 'narrow' | 'nested'

export function getLayoutClasses(layout: ContentLayout) {
	switch (layout) {
		case 'narrow':
			return 'layout layout--narrow'
		case 'nested':
			return 'layout layout--nested'
		default:
			return 'layout layout--wide'
	}
}

export const CMS_BLOCKS_CLASS = 'cms-blocks relative'
export const CMS_BLOCK_CLASS = 'cms-block'

export function tagCMSBlock(blockTypes?: Maybe<string[]>) {
	return [
		CMS_BLOCK_CLASS,
		...(blockTypes?.map((type) => `${CMS_BLOCK_CLASS}--${type}`) ?? []),
	].join(' ')
}
